<script setup lang="ts">
import type { FormKitFrameworkContext } from "@formkit/core";
import type { PropType } from "vue";

import { computed } from "vue";

import { DATA_TEST_IDS } from "@/constants/data-test-ids";

import InputText from "primevue/inputtext";

// TODO : Delete (formkit)

export interface FormKitPrimeInputTextProps {
  placeholder?: string;
  disabled?: boolean;
  optional?: boolean;
}

const props = defineProps({
  context: {
    type: Object as PropType<FormKitFrameworkContext & FormKitPrimeInputTextProps>,
  },
});

const value = computed({
  get: () => {
    return props.context?._value;
  },
  set: (value) => {
    props.context?.node.input(value);
  },
});
</script>

<template>
  <InputText
    v-bind="$attrs"
    :id="props.context?.id"
    v-model="value"
    :placeholder="props.context?.placeholder"
    :disabled="props.context?.disabled"
    class="w-full"
    :class="[props.context?.class]"
    :data-test-id="DATA_TEST_IDS.components.uiTextInput.component"
  />
</template>

<style scoped></style>
